import Nav from "../../components/UI/Nav"
import { useEffect } from "react";
import { useState } from "react";
import Transition from "../../components/UI/Transition";
import ProjectFooter from "../../components/UI/Footer/ProjectFooter";
import { motion } from "framer-motion";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

const emailDesigns = [
    "Emial Mock - Shoppe Welcome.pdf",
    "Email Mock - Studio Welcome.pdf",
    "Email Mock - Studio Story.pdf",
    "Email Mock - Studio Offers.pdf",
    "Email Mock - Studio Events.pdf",
    "Email Mock - Shop NEW IN.pdf",
    "Email Mock - Sale.pdf",
    "Emial Mock - Studio Engagement (projects).pdf",
];

const eventInvitations = [
    "gift-1.png",
    "gift-2.png",
    "Sip&Shop-1.png",
    "Sip&Shop-2.png",
];

const instagramFeeds = [
    "Sale Feed.jpg",
    "Sale Feed 2.jpg",
    "Spring Sale.jpg",
    "Store Sale.jpg",
];

export default function PD() {
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);
    const [eventOpen, setEventOpen] = useState(false);
    const [eventIndex, setEventIndex] = useState(0);
    const [instagramOpen, setInstagramOpen] = useState(false);
    const [instagramIndex, setInstagramIndex] = useState(0);
    const [emailStartIndex, setEmailStartIndex] = useState(0);

    useEffect(() => {
        const scrollToTop = () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        };

        scrollToTop();
    }, []);

    const visibleEmailDesigns = emailDesigns.slice(emailStartIndex, emailStartIndex + 2);

    return (
        <Transition>
            <div
                style={{
                    backgroundColor: '#d4d4d4',
                }}
                className="main__container infj__mainContainer re-padding">
                <div className="menu__fix">
                    <Nav />
                </div>


                <div className="pictok__container" style={{ display: "flex", flexDirection: "column" }}>
                    <section className="qd__topContainer topContainer" style={{ order: 1 }}>

                        <img
                            src="/assets/projects/pd/mockup.png"
                            alt="Pure Design project mockup"
                            style={{
                                width: "100%",
                                maxWidth: "50em",
                                objectFit: "contain",
                                borderRadius: "2em",
                            }}
                        />
                    </section>
                    <section className="pictok__mainContainer" style={{ order: 3 }}>
                        <div className="pictok__mainTitle">
                            <h2>Posters</h2>
                        </div>
                        <div className="pictok__mainContent">
                            <p>
                                During my internship, I created a variety of printed event posters and digital graphics for Instagram, email campaigns, and other marketing channels.
                            </p>
                            <div
                                className="pictok__persona__container"
                                style={{
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "2%",
                                    justifyItems: "center",
                                    width: "100%",
                                    margin: "0 auto",
                                }}
                            >
                                {instagramFeeds.map((feed, feedIndex) => {
                                    const feedPath = `/assets/projects/pd/ins/${encodeURIComponent(feed)}`;

                                    return (
                                        <div
                                            className="pd__emailPreview"
                                            key={feed}
                                            onClick={() => {
                                                setInstagramIndex(feedIndex);
                                                setInstagramOpen(true);
                                            }}
                                        >
                                            <img
                                                className="pictok__userflow pd__emailPdf"
                                                src={feedPath}
                                                alt={`Instagram feed cover ${feedIndex + 1}`}
                                                style={{
                                                    width: "100%",
                                                    height: "16em",
                                                    marginTop: "1em",
                                                }}
                                            />
                                            <p className="pictok__lightbox__notes font-xs">
                                                <strong>{feed.replace(".jpg", "")}</strong>
                                            </p>
                                        </div>
                                    );
                                })}
                            </div>
                            <Lightbox
                                styles={{
                                    container: { backgroundColor: "rgba(25, 25, 25, .9)" }
                                }}
                                open={instagramOpen}
                                index={instagramIndex}
                                close={() => setInstagramOpen(false)}
                                plugins={[Thumbnails]}
                                thumbnails={{
                                    position: "start",
                                    width: 180,
                                    height: 100,
                                    borderRadius: 8,
                                    gap: 12,
                                }}
                                slides={instagramFeeds.map((feed) => ({
                                    src: `/assets/projects/pd/ins/${encodeURIComponent(feed)}`,
                                    title: feed,
                                }))}
                                render={{
                                    thumbnail: ({ slide }) => (
                                        <div style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                            height: "100%",
                                            padding: "0.5em",
                                            color: "white",
                                            backgroundColor: "#555",
                                            textAlign: "center",
                                            fontSize: "0.75em",
                                        }}>
                                            {slide.title}
                                        </div>
                                    ),
                                }}
                            />
                        </div>
                    </section>
                    <section className="pictok__mainContainer" style={{ order: 2 }}>
                        <div className="pictok__mainTitle">
                            <h2>Overview</h2>
                        </div>

                        <div className="pictok__mainContent infj__content">
                            <p>
                                I worked remotely as a graphic design intern at PURE Design. My role included daily morning meetings, collaborating with the team on website updates, and independently creating email campaigns, newsletter templates, digital graphics, and printed posters.
                            </p>
  
                        </div>
                    </section>
                    <section className="pictok__mainContainer" style={{ order: 4 }}>
                        <div className="pictok__mainTitle">
                            <h2>Email Designs</h2>
                        </div>
                        <div className="pictok__mainContent">
                            <p>
                                I created eight cohesive email designs that guide customers from welcoming them to the studio, and introducing the owner, to exploring the shop and discovering special events. Each design uses consistent fonts, layouts, and visual styles.
                            </p>
                            <div className="pd__emailCarousel">
                                <button
                                    className="pd__emailArrow"
                                    type="button"
                                    aria-label="Previous email designs"
                                    onClick={() => setEmailStartIndex(Math.max(0, emailStartIndex - 2))}
                                    disabled={emailStartIndex === 0}
                                >
                                    ‹
                                </button>
                                <div className="pictok__persona__container">
                                {visibleEmailDesigns.map((emailDesign) => {
                                    const emailIndex = emailDesigns.indexOf(emailDesign);
                                    const emailPath = `/assets/projects/pd/emails/${encodeURIComponent(emailDesign)}`;

                                    return (
                                        <div
                                            className="pd__emailPreview"
                                            key={emailDesign}
                                            onClick={() => {
                                                setIndex(emailIndex);
                                                setOpen(true);
                                            }}
                                        >
                                            <iframe
                                                className="pictok__userflow pd__emailPdf"
                                                src={emailPath}
                                                title={emailDesign}
                                                scrolling="no"
                                            />
                                            <p className="pictok__lightbox__notes font-xs">
                                                <strong>{emailDesign.replace(/^(Email|Emial) Mock - /, "").replace(".pdf", "")}</strong>
                                            </p>
                                        </div>
                                    );
                                })}
                                </div>
                                <button
                                    className="pd__emailArrow"
                                    type="button"
                                    aria-label="Next email designs"
                                    onClick={() => setEmailStartIndex(Math.min(emailDesigns.length - 2, emailStartIndex + 2))}
                                    disabled={emailStartIndex >= emailDesigns.length - 2}
                                >
                                    ›
                                </button>
                            </div>
                            <Lightbox
                                styles={{
                                    container: { backgroundColor: "rgba(25, 25, 25, .9)" }
                                }}
                                open={open}
                                index={index}
                                close={() => setOpen(false)}
                                plugins={[Thumbnails]}
                                thumbnails={{
                                    position: "start",
                                    width: 180,
                                    height: 100,
                                    borderRadius: 8,
                                    gap: 12,
                                }}
                                slides={emailDesigns.map((emailDesign) => ({
                                    src: `/assets/projects/pd/emails/${encodeURIComponent(emailDesign)}`,
                                    title: emailDesign,
                                }))}
                                render={{
                                    thumbnail: ({ slide }) => (
                                        <div style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                            height: "100%",
                                            padding: "0.5em",
                                            color: "white",
                                            backgroundColor: "#555",
                                            textAlign: "center",
                                            fontSize: "0.75em",
                                        }}>
                                            {slide.title}
                                        </div>
                                    ),
                                    slide: ({ slide }) => (
                                        <iframe
                                            src={slide.src}
                                            title="Email design PDF"
                                            style={{
                                                width: "90vw",
                                                height: "90vh",
                                                border: "none",
                                                backgroundColor: "white",
                                            }}
                                        />
                                    )
                                }}
                            />
                        </div>

                    </section>
                    <section className="pictok__mainContainer" style={{ order: 5 }}>
                        <div className="pictok__mainTitle">
                            <h2>Event Invite</h2>
                        </div>
                        <div className="pictok__mainContent">
                            <p>
                                For a Mother&apos;s Day special event, I designed two templates of digital invitations: a gift guide and an in-store event invitation. I created two versions of each email, helping attract more guests to the event.</p>
                            <div className="pictok__persona__container">
                                {eventInvitations.map((invitation, invitationIndex) => {
                                    const invitationPath = `/assets/projects/pd/events/${invitation}`;

                                    return (
                                        <div
                                            className="pd__emailPreview"
                                            key={invitation}
                                            onClick={() => {
                                                setEventIndex(invitationIndex);
                                                setEventOpen(true);
                                            }}
                                        >
                                            <img
                                                className="pictok__userflow pd__emailPdf"
                                                src={invitationPath}
                                                alt={`Mother's Day event invitation ${invitationIndex + 1}`}
                                            />
                                            <p className="pictok__lightbox__notes font-xs">
                                                <strong>{invitation.startsWith("Sip&Shop") ? `Sip&Shop ${invitationIndex - 1}` : `Gift Version ${invitationIndex + 1}`}</strong>
                                            </p>
                                        </div>
                                    );
                                })}
                            </div>
                            <Lightbox
                                styles={{
                                    container: { backgroundColor: "rgba(25, 25, 25, .9)" }
                                }}
                                open={eventOpen}
                                index={eventIndex}
                                close={() => setEventOpen(false)}
                                plugins={[Thumbnails]}
                                thumbnails={{
                                    position: "start",
                                    width: 180,
                                    height: 100,
                                    borderRadius: 8,
                                    gap: 12,
                                }}
                                slides={eventInvitations.map((invitation) => ({
                                    src: `/assets/projects/pd/events/${invitation}`,
                                    title: invitation,
                                }))}
                                render={{
                                    thumbnail: ({ slide }) => (
                                        <div style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                            height: "100%",
                                            padding: "0.5em",
                                            color: "white",
                                            backgroundColor: "#555",
                                            textAlign: "center",
                                            fontSize: "0.75em",
                                        }}>
                                            {slide.title}
                                        </div>
                                    ),
                                }}
                            />
                        </div>
                    </section>
                    <section className="pictok__mainContainer" style={{ order: 6 }}>
                        <div className="pictok__mainTitle">
                            <h2>Other</h2>
                        </div>

                        <div className="pictok__mainContent">
                            <p>
                               Due to confidentiality restrictions, I can’t share every project I worked on. Here’s a closer look at a few pieces from my internship, including printable sale tags, window decals, and review cards.
                            </p>
                            <motion.div
                                whileInView={{ x: [-100, 0] }}
                                transition={{ duration: 0.25, delay: 0, type: 'spring', stiffness: '200', damping: '40' }}
                                className="qds__4"
                                style={{
                                    gridTemplateColumns: "repeat(3, 1fr)",
                                    justifyItems: "center",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src="/assets/projects/pd/other/review-1.png"
                                    alt="PURE Design illustration example 1"
                                    style={{ width: "100%", height: "22em", objectFit: "contain" }}
                                />
                                <img
                                    src="/assets/projects/pd/other/Asset%203.png"
                                    alt="PURE Design illustration example 2"
                                    style={{ width: "100%", height: "22em", objectFit: "contain" }}
                                />
                                <img
                                    src="/assets/projects/pd/other/placard-v1.jpg"
                                    alt="PURE Design illustration example 3"
                                    style={{ width: "100%", height: "22em", objectFit: "contain" }}
                                />

                            </motion.div>
                        </div>
                    </section>
                </div>

            </div>

            <ProjectFooter projectName="pure design" />
        </Transition>

    )
}